import { Box, Text, VStack } from '@chakra-ui/react';
import { FormModalWrapper } from '@duke-hq/ui/components/Modals/FormModalWrapper';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { CalendarClock } from 'lucide-react';
import { useStep } from '@duke-hq/ui/components/StepWizard/useStep';
import { useBookCoachingCall } from './useBookCoachingCall';
import { SelectStudent } from './SelectStudent';
import { SelectCourse } from './SelectCourse';

const STEPS = [
  {
    title: () => t`Select student`,
    key: 'SelectStudent',
    component: SelectStudent,
  },
  {
    title: () => t`Select course`,
    key: 'SelectCourse',
    component: SelectCourse,
  },
];

function BookCoachingCallSteps({
  currentStep,
  goToNextStep,
  goToPrevStep,
}: {
  currentStep: number;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}) {
  const stepObj = STEPS[currentStep];

  if (!stepObj) {
    return null;
  }

  const StepComponent = stepObj.component;

  return (
    <StepComponent key={stepObj.key} goToNextStep={goToNextStep} goToPrevStep={goToPrevStep} />
  );
}

function ModalContent() {
  const { currentStep, goToNextStep, goToPrevStep } = useStep({
    maxStep: STEPS.length - 1,
    initialStep: 0,
  });

  return (
    <VStack w="full" h="full" justify="start" gap="16px">
      <Box w="full" h="full">
        <Text fontSize="lg" px="24px" pb="16px" fontWeight="bold">
          <Trans>Book a coaching call</Trans>
        </Text>

        <BookCoachingCallSteps
          currentStep={currentStep}
          goToNextStep={goToNextStep}
          goToPrevStep={goToPrevStep}
        />
      </Box>
    </VStack>
  );
}

export function BookCoachingCallModal({
  variant = 'secondary',
}: {
  variant?: 'primary' | 'secondary' | 'outline';
}) {
  const { isModalOpen, openModal, closeModal } = useBookCoachingCall();

  return (
    <FormModalWrapper
      modalOpenButtonText={t`Book a coaching call`}
      modalOpenButtonLeftIcon={CalendarClock}
      modalOpenButtonVariant={variant}
      modalContent={<ModalContent />}
      isOpen={isModalOpen}
      onClose={closeModal}
      onOpen={openModal}
    />
  );
}
